import { Dispatch, Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import i18n from 'i18n';
import { RootState } from 'data/root.reducers';
import { AxiosError } from 'axios';
import { ServerResponse } from 'data/types';
import { showSuccessMessage, showError } from 'shared/toaster';
import { History } from 'history';
import { extractErrorMessage } from '../../utils';
import * as api from './backup.api';
import {
  FETCH_BACKUP_TASKS,
  DELETE_BACKUP,
  FetchAllBackupTasksAction,
  DeleteBackupFileAction,
  REQUEST_BACKUP_FILE,
  GO_TO_BACKUP_CREATE,
  GO_TO_BACKUP_LIST,
  BackupRequestDTO,
  RequestBackupThunkAction,
  RestoreRequestDTO,
  DELETE_JOB,
  RESTORE_BACKUP_FILE,
  RestoreBackupFileAction,
  DeleteBackupThunkAction,
  RestoreBackupThunkAction
} from './backup.types';
import { BACKUP_RESTORE, SYSTEM_CONFIGURATION_ROUTE, SYSTEM } from '../../constants';

export function getAllBackupTasks(): FetchAllBackupTasksAction {
  return {
    type: FETCH_BACKUP_TASKS,
    payload: api.getAllBackupTasks()
  };
}

export function deleteBackupFile(filename: string, product: string): DeleteBackupFileAction {
  return {
    type: DELETE_BACKUP,
    payload: api.deleteBackupFileByFilename(filename, product)
  };
}

export function deleteJob(product: string, jobId: string): DeleteBackupThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
          type: DELETE_JOB,
          payload: api.deleteJob(product, jobId)
        });
        showSuccessMessage(i18n.t('backupRestore.delete.success', { jobId }), 5000);
    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('backupRestore.delete.failed', { jobId, error: errorMessage }));
    }
  };
}

export function requestBackup(
  body: BackupRequestDTO,
  history: History,
): RequestBackupThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: REQUEST_BACKUP_FILE,
        payload: api.requestBackup(body)
      });

      dispatch(goToBackupRestoreList(history));
      showSuccessMessage(i18n.t('backupRestore.create.success', { product: body.product }), 5000);

    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('backupRestore.create.failed', { product: body.product, error: errorMessage }));
    }
  };
}

export function restoreBackupFile(
  body: BackupRequestDTO
): RestoreBackupThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: RESTORE_BACKUP_FILE,
        payload: api.restoreBackup(body)
      });
      showSuccessMessage(i18n.t('backupRestore.restore.success', { product: body.product }), 5000);

    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('backupRestore.restore.failed', { product: body.product, error: errorMessage }));
    }
  };
}

export function goToBackupCreate(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_BACKUP_CREATE,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${BACKUP_RESTORE}/create`);
  };
}

export function goToBackupRestoreList(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_BACKUP_LIST,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${BACKUP_RESTORE}`);
  };
}
